import API from '@/amplify/api';
import { mcpServerGet } from '@/graphql/queries';
import { mcpServerUpdate } from '@/graphql/mutations';
import Utils from '@/common/utils/utils';
import McpServerApi from '@/common/constant/api/McpServerApi';

export const getMCPServer = async params => {
    try {
        let res = await API.graphql({
            query: mcpServerGet,
            variables: {
                params: {
                    ...params
                }
            }
        });
        return res.data.mcpServerGet;
    } catch (err) {
        console.log('getMCPServer error >>>', err);
        return { success: false };
    }
};

export const updateMCPServer = async requestDto => {
    try {
        let res = await API.graphql({
            query: mcpServerUpdate,
            variables: {
                mcpServerUpdateRequestDto: requestDto
            }
        });
        return res.data.mcpServerUpdate;
    } catch (err) {
        console.log('updateMCPServer error >>>', err);
        return null;
    }
};


export const getMcpServerByIdList = async (idList = []) => {
    if (Utils.isEmptyArray(idList)) return [];

    let response = await getMCPServer({
        getMethod: McpServerApi.MCP_SERVER_GET_METHOD.GET_MCP_SERVER_BY_ID_LIST,
        idList: idList
    });

    let mcpList = [];
    if (response?.success) {
        const payload = Utils.convertJSONDataToObject(response.payload);
        if (!Utils.isEmptyArray(payload?.listItem)) {
            mcpList = payload?.listItem;
        }
    }

    return mcpList.filter(mcp => !Utils.isEmptyObject(mcp));
};

export const getMcpServerByOwnerBy = async (affiliationOrganization, ownerBy) => {
    //comment personal connector
    // if (!affiliationOrganization || !ownerBy) return [];
    // let response = await getMCPServer({
    //     getMethod: Constant.MCP_SERVER_GET_METHOD.GET_MCP_SERVER_BY_OWNER_BY,
    //     corporationInuse: affiliationOrganization,
    //     userId: ownerBy
    // });
    // let mcpList = [];
    // if (response?.success) {
    //     const payload = Utils.convertJSONDataToObject(response.payload);
    //     if (!Utils.isEmptyArray(payload)) {
    //         mcpList = payload;
    //     }
    // }

    // return mcpList.filter(mcp => !Utils.isEmptyObject(mcp));

    return []
};


export const getMcpServerListByProject = async (projectId, userId, corporationId) => {
    if (!projectId || !userId || !corporationId) return [];
    let response = await getMCPServer({
        corporationInuse: corporationId,
        projectInuse: projectId,
        getMethod: McpServerApi.MCP_SERVER_GET_METHOD.GET_LIST_ACTIVE_MCP_BY_PROJECT,
        userId: userId
    });

    let mcpServerList = [];
    const payload = Utils.convertJSONDataToObject(response?.payload);
    if (response?.success && !Utils.isEmptyArray(payload?.listItem)) {
        mcpServerList = payload?.listItem;
    }

    return mcpServerList;
};

export const getMcpCatalogDetailById = async (mcpId) => {
    if (!mcpId) return null;
    try {
        const response = await getMCPServer({
            getMethod: McpServerApi.MCP_CATALOG_GET_METHOD.GET_BY_ID,
            queryParams: JSON.stringify({ mcpId })
        });
    
        const payload = Utils.convertJSONDataToObject(response?.payload);
        return payload || null;
    } catch (error) {
        console.log('getMcpCatalogDetailById error >>>', error);
        return null;
    }
};

export const getListMcpCatalogDetailByIds = async (idList) => {
    if (!idList || Utils.isEmptyArray(idList)) return [];
    try {
        const response = await getMCPServer({
            getMethod: McpServerApi.MCP_CATALOG_GET_METHOD.GET_BY_IDS,
            idList: idList
        });
    
        const payload = Utils.convertJSONDataToObject(response?.payload);
        return payload || [];
    } catch (error) {
        console.log('getListMcpCatalogDetailByIds error >>>', error);
        return [];
    }
};

export const getLocalMcpCatalogList = async () => {
    let response = await getMCPServer({
        getMethod: McpServerApi.MCP_SERVER_GET_METHOD.GET_LOCAL_MCP_CATALOG_LIST
    });

    let catalogList = [];
    const payload = Utils.convertJSONDataToObject(response?.payload);
    if (response?.success && !Utils.isEmptyArray(payload?.listItem)) {
        catalogList = payload?.listItem;
    }

    return catalogList;
}


export const getLocalMcpListForOrg = async (corporationInuse) => {
    let response = await getMCPServer({
        getMethod: McpServerApi.MCP_SERVER_GET_METHOD.GET_LOCAL_MCP_LIST_FOR_ORG,
        corporationInuse
    });

    const payload = Utils.convertJSONDataToObject(response?.payload);
    if (response?.success && !Utils.isEmptyArray(payload?.listItem)) {
        return payload.listItem;
    }

    return [];
};

export const toggleLocalMcpInOrg = async (catId, isActive, corporationInuse, userId) => {
    return await updateMCPServer({
        handleMethod: 'TOGGLE_LOCAL_MCP_IN_ORG',
        corporationInuse,
        userId,
        updateEnableSettingCatalogData: {
            catalogId :catId,
            isActive,
            settingOwner: corporationInuse
        }
    });
};

export const getLocalMcpListForProject = async (corporationInuse, projectInuse, userId) => {
    let response = await getMCPServer({
        getMethod: McpServerApi.MCP_SERVER_GET_METHOD.GET_LOCAL_MCP_LIST_FOR_PROJECT,
        corporationInuse,
        projectInuse,
        userId
    });

    const payload = Utils.convertJSONDataToObject(response?.payload);
    if (response?.success && !Utils.isEmptyArray(payload?.listItem)) {
        return payload.listItem;
    }

    return [];
};

export const toggleLocalMcpInProject = async (catId, isActive, corporationInuse, projectInuse, userId) => {
    return await updateMCPServer({
        handleMethod: McpServerApi.MCP_CATALOG_UPDATE_METHOD.TOGGLE_LOCAL_MCP_IN_PROJECT,
        corporationInuse,
        projectInuse,
        userId,
        updateEnableSettingCatalogData: {
            catalogId: catId,
            isActive,
            settingOwner: projectInuse
        }
    });
};
